import Clock from './clock';
import FullScreen from './full-screen';
import FeedBack from '@component/feed-back/FeedBack';
import Network from '@component/network/Network';
import HeaderInfo from '@component/header-info/HeaderInfo';
import VooVIcon from '@asset/image/logo_with_text.png';
import MeetingEncrypted from './meeting-encrypted';
import './RoomHeader.scss';
import LeaveControl from '@component/control-zoom/leave-control';
import { isMobileBrowser } from '@utils/browser';

const isPhone = isMobileBrowser();
export default function RoomHeader() {
  return (
    <div className="room-header">
      <div className="room-header__item">
        <Network />
        <HeaderInfo />
        {isPhone ? null : (
          <>
            <MeetingEncrypted />
            <FeedBack />
          </>
        )}
      </div>

      {isPhone ? null : (
        <div className="room-header__item room-header__item--full">
          <div className="room-header__icon">
            <img src={VooVIcon} alt="voov logo" className="room-header__logo" />
          </div>
          <div className="room-header__beta-icon">Beta</div>
        </div>
      )}

      <div className="room-header__item">
        {/* 进会计时 */}
        <Clock />

        {/* 全屏 */}
        <FullScreen />
      </div>
      {isPhone ? (
        <div className="room-header__item room-header__item__leave">
          <LeaveControl className="room-header__item__leave__btn" />
        </div>
      ) : null}
    </div>
  );
}
